import React from 'react'
import { Container, Jumbotron, Button, Col, Row } from 'reactstrap'
import './construction.css'
import schuco from './schuco.png'

var Translate = require('react-translate-component')

export default class Schuco extends React.Component {
  render () {
    return (
        <Jumbotron id="schucoJumbotron">
      <Container id="schucoContainer">
        <Row>
          <Col md='6' sm='12' xs='12'>
              <div>
            <img className="schucoImg" src={schuco} alt="logo"></img>
            </div></Col>
          <Col md='6' sm='12' xs='12'>
              <div className="verticallyCentered schucoDescription">
<p class="contentTitle"><Translate content='systemy_schuco' /></p>
<p class="contentConstructionDescription"><Translate content='jestesmy_producentem_okien' /></p>

</div>
          </Col>
        </Row>
      </Container>
      </Jumbotron>
    )
  }
}
